<script setup lang="ts">
interface RelatedLink {
  title: string
  url: string
  description?: string
  type?: 'article' | 'page' | 'product'
}

const props = defineProps<{
  links: RelatedLink[]
  title?: string
}>()

const defaultTitle = 'Contenido Relacionado'
</script>

<template>
  <section v-if="links.length > 0" class="related-links">
    <h3 class="related-links-title">{{ title || defaultTitle }}</h3>
    <div class="related-links-grid">
      <router-link
        v-for="(link, index) in links"
        :key="index"
        :to="link.url"
        class="related-link-card"
      >
        <div class="related-link-content">
          <h4 class="related-link-title">{{ link.title }}</h4>
          <p v-if="link.description" class="related-link-description">
            {{ link.description }}
          </p>
          <span class="related-link-type">{{ link.type || 'Artículo' }}</span>
        </div>
        <svg
          class="related-link-arrow"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M7 17L17 7M17 7H7M17 7V17"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </router-link>
    </div>
  </section>
</template>

<style scoped>
.related-links {
  margin: 60px 0;
  padding: 40px 0;
  border-top: 1px solid #e5e7eb;
}

.related-links-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 30px;
}

.related-links-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
}

.related-link-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: #f8fafc;
  border-radius: 12px;
  text-decoration: none;
  color: inherit;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.related-link-card:hover {
  background: white;
  border-color: #1297ef;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(18, 151, 239, 0.15);
}

.related-link-content {
  flex: 1;
}

.related-link-title {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1e293b;
  margin-bottom: 8px;
  line-height: 1.4;
}

.related-link-description {
  font-size: 0.875rem;
  color: #64748b;
  margin-bottom: 12px;
  line-height: 1.5;
}

.related-link-type {
  display: inline-block;
  padding: 4px 12px;
  background: #e0f2fe;
  color: #1297ef;
  border-radius: 12px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: uppercase;
}

.related-link-arrow {
  color: #1297ef;
  flex-shrink: 0;
  margin-left: 16px;
  transition: transform 0.3s ease;
}

.related-link-card:hover .related-link-arrow {
  transform: translateX(4px);
}

@media (max-width: 768px) {
  .related-links-grid {
    grid-template-columns: 1fr;
  }
}
</style>

